import MultiStepFormLayout from '../Layout/FormLayout';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentStep, updateFormData } from '../features/FormRegistration';
import { getRebate, pushDataLayer } from '../utils/helpers';
import PrimaryButton from '../components/PrimaryButton';
import InfoIcon from '../icons/InfoIcon';
import SelectableOptions from '../components/SelectableOptions';
import SecondaryButton from '../components/SecondaryButton';
import LeftChevron from '../icons/LeftChevron';
import { getTierName, getTierOptionsByCoverType } from '../utils/form/helpers';
import { ShowIf } from '../components/Helpers/ShowIf';

function Step5() {
  const dispatch = useDispatch();
  const { formData } = useSelector((state: any) => state.formRegistration);
  const { isMobileView } = useSelector((state: any) => state.viewport);

  const handleSelectItem = (tierIndex: number) => {
    const rebatePercentage =
      Number.parseFloat(
        (
          Number.parseFloat(
            getRebate(formData.dateOfBirth, tierIndex).slice(0, -1),
          ) / 100
        ).toFixed(5),
      ) || 0;

    dispatch(
      updateFormData({
        ...formData,
        rebatePercentage,
        tierIndex,
      }),
    );
  };

  if (isMobileView) {
    return (
      <MultiStepFormLayout>
        <div className="flex flex-col h-full justify-between px-[5px] md:px-[30px]">
          <h1
            className="header-text text-[20px] !text-start"
            style={{ fontSize: 20 }}>
            What is your annual taxable income?
          </h1>
          <p className="text-[12px] text-[#17385D] text-start mb-5">
            This is to help calculate the correct Australian government rebate.
            The level of government rebate you can claim is based on your yearly
            household (taxable) income and your age.
          </p>

          <h2 className="text-[16px] text-start font-bold mb-5">
            Please select taxable income bracket
          </h2>
          <div className="flex flex-col gap-[16px] w-full mt-4">
            <SelectableOptions
              options={getTierOptionsByCoverType(formData.coverIsFor)}
              value={formData.tierIndex?.toString()}
              className="w-full"
              onChange={(val) => {
                handleSelectItem(Number.parseInt(val));
              }}
            />
          </div>
          <ShowIf condition={formData.tierIndex || formData.tierIndex === 0}>
            <div className="flex flex-col items-start text-start gap-[5px] w-full mt-[10px] p-5 bg-[#D0E7F9] rounded-[10px]">
              <p className="font-normal text-[12px]">
                A{' '}
                <span className="font-bold">
                  {' '}
                  {(formData.rebatePercentage * 100).toFixed(3)}%
                </span>{' '}
                {`(${getTierName(formData.tierIndex)})`} government rebate will
                be applied
              </p>
            </div>
          </ShowIf>
          <div className="flex flex-col items-start text-start gap-[5px] w-full mt-[10px]">
            <InfoIcon style={{ width: 15 }} />
            <div>
              <p className="font-normal text-[12px]">
                Most Australians with private health insurance currently receive
                a rebate from the Australian Government to help cover the cost
                of their premiums. The private health insurance rebate is income
                tested. Please select taxable income bracket.
              </p>
            </div>
          </div>
          <div className="w-full justify-between h-full flex  items-center gap-[10px] sticky bottom-0 bg-[white] p-4 z-10 border-t border-[#D1D7DF] mt-6">
            <SecondaryButton
              leftSection={<LeftChevron />}
              onClick={() => {
                dispatch(setCurrentStep(4));
              }}>
              Previous
            </SecondaryButton>
            <PrimaryButton
              style={{
                alignSelf: 'center',
              }}
              disabled={formData.tierIndex === null}
              text="Continue"
              classNames="w-[50%] md:w-auto"
              onClick={() => {
                pushDataLayer('funnel_rebate', {
                  rebate_tier: `${formData.tierIndex}`,
                });
                dispatch(setCurrentStep(7));
              }}
            />{' '}
          </div>
        </div>
      </MultiStepFormLayout>
    );
  }

  return (
    <MultiStepFormLayout>
      <div className="flex flex-col h-full justify-between ">
        <h1
          className="header-text text-[20px] !text-start"
          style={{ fontSize: 20 }}>
          What is your annual taxable income?
        </h1>
        <p className="text-[12px] text-[#17385D] text-start mb-5">
          This is to help calculate the correct Australian government rebate.
          The level of government rebate you can claim is based on your yearly
          household (taxable) income and your age.
        </p>

        <h2 className="text-[16px] text-start font-bold mb-5">
          Please select taxable income bracket
        </h2>
        <div className="flex flex-col gap-[16px] w-full mt-4">
          <SelectableOptions
            options={getTierOptionsByCoverType(formData.coverIsFor)}
            value={formData.tierIndex?.toString()}
            className="w-full"
            optionClassname="w-full"
            onChange={(val) => {
              handleSelectItem(Number.parseInt(val));
            }}
          />
        </div>
        <ShowIf condition={formData.tierIndex || formData.tierIndex === 0}>
          <div className="flex flex-col items-start text-start gap-[5px] w-full mt-[10px] p-5 bg-[#D0E7F9] rounded-[10px]">
            <p className="font-normal text-[12px]">
              A{' '}
              <span className="font-bold">
                {' '}
                {(formData.rebatePercentage * 100).toFixed(3)}%
              </span>{' '}
              {`(${getTierName(formData.tierIndex)})`} government rebate will be
              applied
            </p>
          </div>
        </ShowIf>
        <div className="flex flex-col items-start text-start gap-[5px] w-full mt-[10px]">
          <InfoIcon style={{ width: 15 }} />
          <div>
            <p className="font-normal text-[12px]">
              Most Australians with private health insurance currently receive a
              rebate from the Australian Government to help cover the cost of
              their premiums. The private health insurance rebate is income
              tested. Please select taxable income bracket.
            </p>
          </div>
        </div>
        <div className="w-full justify-between h-full flex  items-center gap-[10px] sticky bottom-0 bg-[white] p-4 z-10 border-t border-[#D1D7DF] mt-6">
          <SecondaryButton
            leftSection={<LeftChevron />}
            onClick={() => {
              dispatch(setCurrentStep(4));
            }}>
            Previous
          </SecondaryButton>
          <PrimaryButton
            style={{
              alignSelf: 'center',
            }}
            disabled={formData.tierIndex === null}
            text="Continue"
            classNames="w-[50%] md:w-auto"
            onClick={() => {
              pushDataLayer('funnel_rebate', {
                rebate_tier: `${formData.tierIndex}`,
              });
              dispatch(setCurrentStep(7));
            }}
          />{' '}
        </div>
      </div>
    </MultiStepFormLayout>
  );
}

export default Step5;
